<template>
  <div class="union__item">
    <ul class="union__header">
      <li class="union__title">
        {{title}}
      </li>
    </ul>

    <el-card shadow="hover" class="union__card" v-loading="isPending">
      <union-body
        :city-list="cityArr"
        :active-city="activeCity"
        :synonym="synonym"
        @setCity="setCity"
        @setSynonym="setSynonym"
        @toUnion="toUnion"
      />
      <div class="union-footer">
        <el-button type="primary" @click="openCityList">{{$t('feed.audit.unionCity.dialog.openButton')}}</el-button>
      </div>
    </el-card>

    <el-dialog :title="$t('feed.audit.unionCity.dialog.title')" :visible.sync="dialogCityVisible">
      <ul class="city-top-list">
        <li class="city-top-list__item" v-for="(item, index) in cityArr" :key="index">
          {{item}}
        </li>
      </ul>
    </el-dialog>
  </div>
</template>

<script>
  // components
  import UnionBody from './body/UnionBody';

  // api
  import { getCityApi, addSinonymApi, getCityTopApi } from '@/api/stats';

  export default {
    name: "Geo",
    data() {
      return {
        name: "UnionCity",
        title: this.$t('feed.audit.unionCity.title'),
        pending: false,
        cityArr: [],
        cityTop: [],
        activeCity: 'Санкт-Петербург',
        synonym: 'Санкт-Петербург',
        dialogCityVisible: false
      };
    },
    methods: {
      openCityList() {
        /*if (!this.cityTop.length) {
          this.pending = true;

          const params = {
            thread_id: this.$route.params.threadId
          };

          getCityTopApi(params).then((resp) => {
            this.pending = false;
            this.cityTop = resp.data.sort((a, b) => {
              if(a.city < b.city) {
                return -1;
              }
              if(a.city > b.city) {
                return 1;
              }
              return 0;
            });
            this.dialogCityVisible = true;
          });
        } else {
          this.dialogCityVisible = true;
        }*/
        this.dialogCityVisible = true;
      },
      setCity(value) {
        this.activeCity = value;
      },
      setSynonym(value) {
        this.synonym = value;
      },
      toUnion({city, synonym}) {
        this.pending = true;

        const params = {
          city,
          sinonym: synonym
        };

        return addSinonymApi(params).then(() => {
          this.pending = false;
          return Promise.resolve();
        })
      }
    },
    computed: {
      isPending() {
        return this.pending;
      },
    },
    mounted() {
      this.pending = true;

      const params = {
        thread_id: this.$route.params.threadId
      };

      getCityApi(params).then((resp) => {
        this.cityArr = resp.data;
        //this.activeCity = this.cityArr[0];
        //this.synonym = this.cityArr[0];
        this.pending = false;
      });
    },
    components: {
      UnionBody,
    }
  }
</script>

<style>

  .union__item {
    flex-basis: 50%;
    margin-right: 20px;
  }

  .union__item:last-child {
    margin-right: 0;
  }

  .union__card {
    margin-bottom: 20px;
  }


  .union__header {
    display: flex;
    justify-content: space-between;
    align-items: start;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .union__title {
    margin-bottom: 20px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #5E6D82;
  }

  .union__tools .material-icons {
    font-size: 16px;
  }

  .union-footer{
    display: flex;
    justify-content: flex-end;
    margin-top: 237px;
  }

  .city-top-list {
    padding: 0;
    margin: 0;
    list-style: none;
    -webkit-column-count: 3;
    -moz-column-count: 3;
    column-count: 3;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
  }
</style>

